import { BRAND } from '@/constants';

const values = [
  {
    icon: 'ri-shield-check-line',
    title: 'Équipe formée',
    desc: 'Praticiens formés et à l’écoute',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Soins personnalisés',
    desc: 'Chaque séance adaptée à vos besoins',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Approche naturelle',
    desc: 'Ventouses verre & bambou, huiles adaptées',
  },
  {
    icon: 'ri-user-smile-line',
    title: 'Suivi patient',
    desc: 'Écoute avant et conseils après le soin',
  },
];

export default function About() {
  return (
    <section id="a-propos" className="py-20 px-6 scroll-mt-[84px] bg-[#f6f3ec]">
      <div className="max-w-[1180px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div>
          <span className="text-[#0b6b52] text-xs font-semibold tracking-widest uppercase mb-4 block">
            Notre Cabinet
          </span>
          <h2
            className="text-[clamp(34px,4.4vw,52px)] font-bold leading-[1.12] text-[#173029] mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            LIFECUPP
            <span className="block text-[#0b6b52] italic">by bien-être</span>
          </h2>

          <p className="text-base leading-relaxed text-[#57534a] mb-4 text-pretty">
            Bienvenue chez <strong className="text-[#22201c]">{BRAND.name}</strong>, votre espace dédié
            au cupping thérapie et au bien-être à {BRAND.city}. Nous accueillons chaque personne pour
            écouter ses douleurs, ses objectifs, puis proposer un protocole adapté.
          </p>
          <p className="text-base leading-relaxed text-[#57534a] mb-9 text-pretty">
            Nos praticiens (dont Ayoub et une praticienne) allient technique des ventouses et cadre
            calme, hygiénique et bienveillant. La consultation initiale est gratuite.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
            {values.map((v) => (
              <div
                key={v.title}
                className="flex items-start gap-3 bg-white border border-[#e8e2d4] rounded-[14px] p-4"
              >
                <i className={`${v.icon} text-[#0b6b52] text-xl flex-shrink-0`}></i>
                <div>
                  <div className="font-semibold text-sm text-[#22201c]">{v.title}</div>
                  <div className="text-[12.5px] text-[#8a8578] mt-0.5">{v.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3.5">
          <div className="col-span-2 rounded-[18px] overflow-hidden h-[290px]">
            <img
              src="https://storage.readdy-site.link/project_files/9a8570c6-f50d-49ad-8ac8-35ff8d1a4c26/bb0a06b0-3c84-4180-9e82-a3c58033cb13_pohoto-hij.jpg?v=16a84194eae7858bc33fe9551895458d"
              alt={`Cabinet ${BRAND.name}`}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="rounded-[18px] overflow-hidden h-[200px]">
            <img
              src="https://storage.readdy-site.link/project_files/9a8570c6-f50d-49ad-8ac8-35ff8d1a4c26/e55a1ba9-32d8-42d4-94d8-2b1d2e894ebc_photo-hija.jpg?v=cfeeab618d2254984db3ead151761d1c"
              alt="Séance de cupping au cabinet"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="rounded-[18px] overflow-hidden h-[200px]">
            <img
              src="https://storage.readdy-site.link/project_files/9a8570c6-f50d-49ad-8ac8-35ff8d1a4c26/ff39044a-4201-4906-bce5-2282369acfff_photo-hijam.jpg?v=84ae7e5e4678f210423f3e6468957296"
              alt="Soin ventouses professionnel"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
